"use client";

import React, { useState } from "react";
import { ChevronDown } from "react-feather";

const AboutUs: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <section className="w-full max-w-[1440px] mx-auto px-4 flex flex-col items-center lg:my-20 mt-10">
      <div
        className={`w-full rounded-md overflow-hidden lg:mb-6 mb-5 text-[#303030] font-normal lg:text-xl text-sm ${isOpen ? "bg-white" : "bg-[#F8FFFE]"}`}
      >
        <button
          className="w-full flex justify-between items-center py-4 px-6 text-left focus:outline-none font-semibold font-serif lg:text-3xl text-xl text-[#3a3939]"
          onClick={toggleDropdown}
        >
          About Us
          <span
            className={`transition-transform transform ${isOpen ? "rotate-180" : ""}`}
          >
            <ChevronDown color="#787878ff" size={30}/>
          </span>
        </button>
        {isOpen && (
          <div className="px-4 md:px-6 py-4 border-t border-gray-200 text-gray-700 font-urbanist">
            <p className="text-sm md:text-base">
              Welcome to Tooffi — India’s dedicated gifting marketplace for those who value thoughtful gifts rooted in craft, culture, and meaningful stories —made by Indian creators who care deeply about their craft
            </p>
            <p className="text-sm md:text-base mt-4">
              We believe India has outgrown predictable cake-and-flower combos and mass-produced keepsakes. Today, gifting is about meaning.
            </p>
            <p className="text-sm md:text-base">
              At Tooffi, we bring together the finest craftsmen and the most creative independent Indian brands from across the country. We curate handcrafted, artisanal, and consciously made products from passionate independent Indian brands — giving them the visibility they deserve, and you the joy of discovering something truly special.
            </p>
            <p className="text-sm md:text-base">
              From luxury food gifts and artisanal honey to sustainable hampers and premium wellness collections, every product on Tooffi carries a story — of heritage, purpose, and craftsmanship. When you gift from Tooffi, you don’t just share a product. You share a story, support a creator, and create a memory that lasts.
              Tooffi is not just a marketplace. It’s a better way to gift.
            </p>

            <h3 className="text-xl md:text-2xl font-semibold font-montserrat mt-6">Our Mission</h3>
            <p className="text-sm md:text-base ">
              At Tooffi, our mission is simple yet deeply meaningful — to make gifting a heartfelt experience for everyone involved.
            </p>
            <p className="text-sm md:text-base ">
              Because gifting is never just about an occasion. It’s about connection. A birthday, a festival, a quiet thank you, or a simple “I’m thinking of you” — these moments strengthen the bonds that shape our lives.
            </p>
            <p className="text-sm md:text-base ">We believe the right gift is more than an object. It is an emotion wrapped in intention. A reflection of care. A small but powerful way of saying, you matter.
              That’s why we thoughtfully curate high-quality, handcrafted gifts made with love and purpose — pieces that don’t just sit on a shelf, but touch hearts, spark smiles, and stay in memory long after they’re opened.
              At Tooffi, we’re here to help you gift with meaning.</p>

            <h3 className="text-xl md:text-2xl font-semibold font-montserrat mt-6">What We Offer</h3>
            <p className="text-sm md:text-base">
              Only thoughtful gifts born from craft & culture - each one carries an Indian maker’s story.
            </p>
            <p className="text-sm md:text-base">Handmade soaps, coffee, art, honey, toys, tea, spices, plants, bakes & more — every gift is born out of passion and wrapped with care.</p>
            <p className="text-sm md:text-base">From personalized keepsakes to unique gifts and custom-made creations, our platform offers an array of products that cater to all tastes, preferences, and budgets. Whether you're looking for a handcrafted gift, a fun surprise, or a heartfelt gesture, you’ll find something special at Tooffi.</p>
            <p className="text-sm md:text-base">Think creative, thoughtful, story-filled gifts from independent Indian brands — not boring, mass-produced stuff.</p>
            <ul className="list-disc list-inside text-sm md:text-base">
              <li>
                Premium and artisanal gift hampers
              </li>
              <li>
                Sustainable and ethically sourced products
              </li>
              <li>
                Handcrafted gourmet food gifts
              </li>
              <li>
                Unique gifts that support small businesses
              </li>
            </ul>

            <h3 className="text-xl md:text-2xl font-semibold font-montserrat mt-6">Why Choose Us?</h3>
            <ul className="list-disc pl-4 text-sm md:text-base">
              <li>
                Thoughtful Gifting Made Easy: We understand that finding the right gift can be challenging, so we’re here to help! Our platform is designed to make the gift selection process effortless and enjoyable. We partner with only passionate merchants & individuals who love what they do. Every product on our platform is carefully chosen.
              </li>
              <li>
                Customer Satisfaction: We prioritise your happiness. Our team is committed to providing excellent customer service and ensuring that every order exceeds your expectations.
              </li>
              <li>
                Wide Range of Choices: From the traditional to the unique, we offer a diverse range of gifts that suit all ages, personalities, and occasions. You can order wellness products, Snack Hampers, Honey, Dry fruit Hampers, Handmade art & craft, Handmade chocolates and many more categories.
              </li>
              <li>
                Fast Delivery & Hassle-Free Returns: Get your gifts delivered on time and enjoy the flexibility of easy returns and exchanges.
              </li>
              <li>Secure Payments with Cashfree</li>
            </ul>

            <h3 className="text-xl md:text-2xl font-semibold font-montserrat mt-6">Our Promise</h3>
            <p className="text-sm md:text-base">
              At Tooffi, we promise to always put the needs of our customers first. Every gift is carefully selected, packaged with care, and delivered on time. We believe in the power of gifting to create meaningful connections, and we are honored to be part of your special moments.
            </p>

            <h3 className="text-xl md:text-2xl font-semibold font-montserrat mt-6">
              Join Us in Celebrating Every Occasion
            </h3>
            <p className="text-sm md:text-base">
              We invite you to explore our platform and find the perfect gift for your loved ones today. Whether you’re near or far, Tooffi is here to make every occasion unforgettable with just the right gift. Thank you for choosing Tooffi, where thoughtful gifting meets convenience!
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default AboutUs;
